import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Settings|Affiliation Form';

const sharedLocDefs: Pick<LocDef, 'feature' | 'portal' | 'htmlAllowed' | 'shared'> = {
	feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
};

export type SpAffiliationFormLocs = '3b93f432bd954514a78b2a4e834a3702';

export const spAffiliationFormLocs: LocDefs<SpAffiliationFormLocs> = {
	'3b93f432bd954514a78b2a4e834a3702': {
		...sharedLocDefs,
		defaultValue: 'Affiliation ID already in use',
		displayPath: `${dpRoot}|Duplicate Affiliation ID Error`,
		description: 'Error displayed when an Affiliation ID already in use.',
		displayType: 'Error',
	},
};

export const SpAffiliationFormLocs = MapLocKeys<SpAffiliationFormLocs>(spAffiliationFormLocs);
